/* 创建者 左晨(2019.07.24) 奖金积分转商城购物积分页面 */
<template>
  <div>
    <div class="header">
      <img
        src="../../assets/images/account_logo.png"
        width="200"
      />
    </div>
    <div class="cz-con">
      <div class="inner">
        <div class="breadcrumb-layout">
          <div class="breadcrumb wrapper">
            <span>
              <router-link to="/account-center">我的账户</router-link>
            </span>
            <span class="arrow">&gt;</span>
            <span>{{ name }}</span>
          </div>
        </div>
        <div class="search-box">
          <Row style="height: 41px; line-height: 41px">
            <Col
              span="2"
              style="text-align: right"
            > 日期： </Col>
            <Col
              span="8"
              style="box-sizing: border-box !important"
            >
            <DatePicker
              type="daterange"
              :confirm="true"
              :transfer="true"
              :clearable="false"
              size="small"
              class="datepicker"
              v-model="searchDate"
            ></DatePicker>
            </Col>
            <Col span="2">
            <Button
              size="small"
              @click.native="searchEvent"
            >查询</Button>
            </Col>
          </Row>
        </div>
        <div
          class="content"
          style="margin-top: 10px"
        >
          <div class="box">
            <Table
              class="item-table"
              :columns="column"
              :data="pointList"
              no-data-text="无数据"
            ></Table>
            <Page
              class="item-page"
              v-if="total"
              :total="total"
              show-total
              show-elevator
              @on-change="changePage"
              :current="query.pageNo"
              style="float: right; margin-top: 10px"
              :page-size="query.pageSize"
            ></Page>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getPointItem, getPointItemNew } from "api/user";
import { parseTime, getSession } from "utils/tool";
import moment from "moment";

const MAP = {
  // 13: "冻奖金积分(推荐会员奖励)",
  // 14: "冻奖金积分(消费全返专区消费奖励)",
  // 15: "消费全返专区直接分享会员消费累计",
  8916: "免费换购积分明细",
  8895: "自营购物积分明细",
  8980: "自营订单明细",
  8917: "店长订单明细",
  8929: "红包积分明细",
  8891: "商家余额明细",
  8830: "分享奖励明细",
  8601: "购物奖励积分明细",
};

export default {
  data() {
    return {
      total: 0,
      pointList: [],
      searchDate: [],
      query: {
        loginName: getSession("userName"),
        loginUserId: getSession("memberId"),
        pageNo: 1,
        pageSize: 10,
        startDate: undefined,
        endDate: undefined,
        consumeType: 0,
        currencyTypeId: "",
      },
      column: [
        {
          title: "交易类型",
          align: "center",
          width: 300,
          key: "transName",
          render: (h, params) => {
            const {
              row: { remark, transName },
            } = params;
            let texts = "";
            if (this.$route.query.type == 8917) {
              texts = "店长消费累计";
            } else {
              texts = transName;
            }
            return h(
              "div",
              {
                props: {},
              },
              texts
            );
          },
        },
        {
          title: "来源",
          align: "center",
          width: 300,
          key: "traderName",
          render: (h, params) => {
            const {
              row: { remark, traderName, transName },
            } = params;
            let texts = "";
            if (
              this.$route.query.type == 8904 ||
              this.$route.query.type == 8917 ||
              this.$route.query.type == 8980 ||
              this.$route.query.type == 8916
            ) {
              texts = remark ? remark : traderName;
            } else {
              texts = traderName;
            }
            return h(
              "div",
              {
                props: {},
              },
              texts
            );
          },
        },
        {
          title: "交易金额",
          align: "center",
          // width: 200,
          key: "money",
          render: (h, params) => {
            const {
              row: { expenditure, income },
            } = params;
            let res = income - expenditure;
            let sign = "";
            if (res > 0) sign = "+";
            if (res < 0) sign = "-";
            let texts = `${sign}${Math.abs(res).toFixed(2)}`;
            // if (this.$route.query["type"] == "16") {
            //   texts = `${sign}${Math.abs(res).toFixed(2)}`;
            // }
            return h(
              "div",
              {
                props: {},
              },
              texts
            );
          },
        },
        {
          title: "交易时间",
          align: "center",
          width: 200,
          key: "completeTime",
        },
      ],
    };
  },
  created() {
    // if (this.$route.query.type == 16) {
    //   // 现金消费当月累计
    //   this.query.currencyTypeId = 8916;
    // } else if (this.$route.query.type == 8891) {
    //   // 商家余额
    //   this.query.currencyTypeId = 8891;
    // } else if (this.$route.query.type == 8980) {
    //   // 自营消费月消费累计
    //   this.query.currencyTypeId = 8980;
    // } else if (this.$route.query.type == 8917) {
    //   // 店长采购积分消费月消费累计
    //   this.query.currencyTypeId = 8917;
    // } else if (this.$route.query.type == 8929) {
    //   // 店长采购积分消费月消费累计
    //   this.query.currencyTypeId = 8929;
    // } else if (this.$route.query.type == 8888) {
    //   this.query.currencyTypeId = 8888;
    // } else {
    //   // 返购积分
    //   this.query.currencyTypeId = 8895;
    // }
    this.query.currencyTypeId = this.$route.query.type;
    this.name = MAP[this.$route.query.type] || "奖金积分明细";
    const start =
      this.query.currencyTypeId == 8980 || this.query.currencyTypeId == 8917
        ? new Date(moment().startOf("month").valueOf())
        : new Date(moment().subtract(7, "days").valueOf());
    const end = new Date(moment().valueOf());
    this.searchDate.push(start);
    this.searchDate.push(end);
    this.searchEvent();
  },
  methods: {
    searchEvent() {
      if (this.searchDate.length === 0) {
        this.$Message.warning("请输入订单查询条件!");
        return;
      }
      this.getPointItem();
    },
    getPointItem() {
      this.query.startDate = moment(this.searchDate[0]).format("YYYY-MM-DD");
      this.query.endDate = moment(this.searchDate[1]).format("YYYY-MM-DD");
      let data = Object.assign({}, this.query);
      if (
        this.query.currencyTypeId == 8980 ||
        this.query.currencyTypeId == 8917
      ) {
        data.consumeType = 1;
      }
      getPointItemNew(data).then((res) => {
        if (res.resCode == 1) {
          const data = res.data;
          this.pointList = data.list;
          this.total = data.total;
        }
      });
    },
    changePage(pageNo) {
      this.query.pageNo = pageNo;
      this.getPointItem();
    },
  },
};
</script>
<!--<style lang="less" scoped>-->
<!--@import "../../assets/css/showTransfer.less";-->
<!--</style>-->
<style scoped>
.search-box {
  margin-top: 15px;
  /*border-radius: 5px;*/
  background-color: #ffffff;
  border: 1px solid #dbdbdb;
}
.datepicker {
  width: 200px;
  box-sizing: border-box !important;
}
.datepicker input {
  padding-right: 0 !important;
}
.content {
  height: 360px;
}
</style>
<style>
.item-table .ivu-table td,
.ivu-table th {
  height: 30px !important;
  line-height: 30px !important;
}
.cz-con .inner .content {
  font-size: 14px !important;
}
</style>



// WEBPACK FOOTER //
// pointItem.vue?ff190ebe